module.exports = __webpack_public_path__ + "img/healt.93856253.jpg";